export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const ADD_CUSTOMER_COMPLETED = "ADD_CUSTOMER_COMPLETED";
export const ADD_CUSTOMER_FAILED = "ADD_CUSTOMER_FAILED";

export const GET_CUSTOMER = "GET_CUSTOMER";
export const GET_CUSTOMER_COMPLETED = "GET_CUSTOMER_COMPLETED";
export const GET_CUSTOMER_FAILED = "GET_CUSTOMER_FAILED";

// Détail client (lecture seule) — fiche client en surcouche.
// L'endpoint renvoie l'objet client directement (pas d'enveloppe).
export const getCustomer = (id) => ({
  type: GET_CUSTOMER,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/customers/${id}.json`,
    method: "GET",
    params: {},
  },
});

export const addCustomer = (customerInfo) => ({
  type: ADD_CUSTOMER,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/customers`,
    method: "POST",
    body: {customer: customerInfo}
  },
});
